import {Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {environment} from "../../../environments/environment";
import {PageService} from "../../service/page/page.service";
import {PagePartnerView, PartnerItem} from "../../service/page/page";


@Component({
  selector: 'app-partners',
  templateUrl: 'partners.component.html',
  styleUrls: ['partners.component.scss'],
  providers: [PageService]
})
export class PartnersComponent implements OnInit {
  en: boolean;
  category_id: Number;

  allCategories: PagePartnerView[] = [];
  group: PagePartnerView;

  constructor(private pageService: PageService, private route: ActivatedRoute) {
    this.en = environment.english;
  }

  async ngOnInit(): Promise<any> {
    let categories = await this.pageService.getPartnerCategory();

    this.allCategories = await Promise.all(categories.map(async (item) :Promise<PagePartnerView> => {
      let ko_title = item.name.replace(/[^\uAC00-\uD7AF\u1100-\u11FF\u3130-\u318F]/gi," ").trim()
      let en_title = item.name.replace(/[^a-z]/gi," ").trim()
      let partners =  await this.initPartnership(item.id)

      return {
        id: item.id,
        title : this.en ? en_title : ko_title,
        detail : item.detail,
        partners,
      }
    }));

    this.setUpURL();
  }

  async initPartnership(id){
    return await this.pageService.getPartner(id)
  }

  setUpURL() {
    this.route.params.subscribe(
      params => {
        this.category_id = params['category'] ? params['category'] : this.allCategories[0]['id'];
        this.filter();
      }
    );
  }

  filter() {
    this.group = this.allCategories.filter(group => group.id == this.category_id)[0];
    // console.log(this.group)
  }
}



// WEBPACK FOOTER //
// ./src/app/heyground/partners/partners.component.ts